import { PlanType } from '@dtx-company/true-common/src/types/planType'

const planTypeOrder = [
  PlanType.FREE,
  PlanType.PRO,
  PlanType.PRO_PLUS_ORG,
  PlanType.PRO_FLEX,
  PlanType.PILOT,
  PlanType.ENTERPRISE
]

/**
 * Returns a number indicative of whether the user is moving to a higher tier plan
 * (n > 0 => UPGRADING), lower tier plan (n < 0 DOWNGRADING) or stayin in the same (n = 0)
 *
 * Todo: Remove once determining the plan direction has moved to business logic in the back-end
 */
export function getPlanTypeDirection(userPlanType: PlanType, otherPlanType: PlanType): number {
  const userOrder = planTypeOrder.indexOf(userPlanType) || 0
  const otherOrder = planTypeOrder.indexOf(otherPlanType) || 0
  return otherOrder - userOrder
}
